import { Alert, Snackbar as MuiSnackbar } from '@mui/material';

import { AlertCircleIcon, CheckCircleIcon, HelpCircleIcon } from '@shared/ui/icons';

import { useSnackbarStore } from '../model';

export const Snackbar = () => {
  const snackbar = useSnackbarStore();

  return (
    <MuiSnackbar
      open={snackbar.isOpen}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={5000}
      onClick={snackbar.hide}
      onClose={snackbar.hide}
    >
      <Alert
        severity={snackbar.severity}
        iconMapping={{
          success: <CheckCircleIcon sx={{ color: 'success.main' }} />,
          error: <AlertCircleIcon sx={{ color: 'error.main' }} />,
          warning: <AlertCircleIcon sx={{ color: 'warning.main' }} />,
          info: <HelpCircleIcon sx={{ color: 'info.main' }} />,
        }}
        onClose={snackbar.hide}
      >
        {snackbar.message}
      </Alert>
    </MuiSnackbar>
  );
};
